import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

export const trendsApi = createApi({
    reducerPath: "trendsApi", baseQuery: fetchBaseQuery({baseUrl: "/api/stats/"}), endpoints: (builder) => ({
        getStatsHistory: builder.query({
            query: ({workspaceNumber, size}) => {
                const params = new URLSearchParams({
                    workspaceNumber: String(workspaceNumber), size: String(size),
                });
                return `history?${params.toString()}`;
            }, keepUnusedDataFor: 60, // seconds
        }),
    }),
});

export const {useGetStatsHistoryQuery, useLazyGetStatsHistoryQuery} = trendsApi;
